import { defineMessages } from 'react-intl';

export default defineMessages({
    type: {
        id: 'ml.quoteandbind.hoexcludedanimals.type',
        defaultMessage: 'Type'
    },
    breed: {
        id: 'ml.quoteandbind.hoexcludedanimals.breed',
        defaultMessage: 'Breed'
    },
    name: {
        id: 'ml.quoteandbind.hoexcludedanimals.name',
        defaultMessage: 'Name'
    },
    birthYear: {
        id: 'ml.quoteandbind.hoexcludedanimals.birthYear',
        defaultMessage: 'Birth Year'
    },
    distinctiveMarks: {
        id: 'ml.quoteandbind.hoexcludedanimals.distinctiveMarks',
        defaultMessage: 'Distinctive Markings or Tattoo(s)'
    }
});
